module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/fallback_blue-e1544989a964217820c6a8a14681bbec.svg";